import { ComponentType } from "react";
import useScreenSize from "../../hooks/device-detection.hook";

type WithResponsiveRenderingProps<T> = {
  MobileComponent: ComponentType<T>;
  DesktopComponent: ComponentType<T>;
};

// Define a generic type T for props
const WithResponsiveRendering = <T extends object>({
  MobileComponent,
  DesktopComponent,
}: WithResponsiveRenderingProps<T>) => {
  const WithResponsiveRenderingComponent = (props: T) => {
    const { isMobile } = useScreenSize();
    return isMobile ? (
      <MobileComponent {...props} />
    ) : (
      <DesktopComponent {...props} />
    );
  };
  return WithResponsiveRenderingComponent;
};
export default WithResponsiveRendering;

